import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import MenuContainer from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreIcon from '@mui/icons-material/MoreVert';
import Typography from '@mui/material/Typography';
import SettingsIcon from '../../icons/SettingsIcon';
import IconButton from '@mui/material/IconButton';

import BackgroundOptionsDialog from '../BackgroundOptionsDialog';
import RoomMonitorDialog from '../RoomMonitorDialog';
import DeviceSelectionDialog from '../DeviceSelectionDialog';

export default function SettingsMenu({
  mobileButtonClass,
}: {
  mobileButtonClass?: string;
}) {
  const isMobile = false; //useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const [menuOpen, setMenuOpen] = useState(false);

  const [deviceSettingsOpen, setDeviceSettingsOpen] = useState(false);
  const [roomMonitorOpen, setRoomMonitorOpen] = useState(false);
  const [backgroundSettingsOpen, setBackgroundSettingsOpen] = useState(false);

  const anchorRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      {isMobile ? (
        <Button
          ref={anchorRef}
          onClick={() => setMenuOpen(true)}
          startIcon={<MoreIcon />}
          className={mobileButtonClass}>
          More
        </Button>
      ) : (
        <IconButton
          ref={anchorRef}
          size="small"
          onClick={() => setMenuOpen(true)}>
          <SettingsIcon />
        </IconButton>
      )}
      <MenuContainer
        open={menuOpen}
        onClose={() => setMenuOpen((isOpen) => !isOpen)}
        anchorEl={anchorRef.current}
        //getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'top',
          horizontal: isMobile ? 'left' : 'right',
        }}
        transformOrigin={{
          vertical: 0,
          horizontal: 'center',
        }}>
        <MenuItem onClick={() => setDeviceSettingsOpen(true)}>
          <Typography variant="body1">Audio and Video Settings</Typography>
        </MenuItem>

        <MenuItem onClick={() => setBackgroundSettingsOpen(true)}>
          <Typography variant="body1">Background</Typography>
        </MenuItem>

        <MenuItem onClick={() => setRoomMonitorOpen(true)}>
          <Typography variant="body1">Video Room Monitor</Typography>
        </MenuItem>
      </MenuContainer>

      <DeviceSelectionDialog
        open={deviceSettingsOpen}
        onClose={() => {
          setDeviceSettingsOpen(false);
          setMenuOpen(false);
        }}
      />

      <BackgroundOptionsDialog
        open={backgroundSettingsOpen}
        onClose={() => {
          setBackgroundSettingsOpen(false);
          setMenuOpen(false);
        }}
      />

      <RoomMonitorDialog
        isOpen={roomMonitorOpen}
        onClose={() => {
          setRoomMonitorOpen(false);
          setMenuOpen(false);
        }}
      />
    </>
  );
}
